import zipCodeTest from "../../settings/yup/tests/zipCodeTest";
import yup from "../../settings/yup";

const zipCodeSchema = {
  zipCode: yup
    .string()
    .test({ ...zipCodeTest, message: "Bitte geben Sie eine gültige PLZ ein." })
    .required("Bitte geben Sie eine gültige PLZ ein.")
  ,
};

export default zipCodeSchema;
